import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  name: 'María José',
  location: 'Buenos Aires',
  initials: 'MJ',
  color: 'bg-maternal-amber',
  quote: 'El día 3 mi hijo me preguntó qué había para cenar. Parece poco, pero hacía meses que no me dirigía la palabra voluntariamente. Al día 7, tuvimos una charla de 20 minutos en el auto. Lloré de alegría.'
}, {
  name: 'Carolina',
  location: 'Córdoba',
  initials: 'C',
  color: 'bg-maternal-orange',
  quote: 'Yo era de las que gritaba y después se sentía culpable. Con la técnica de la Roca Calma aprendí a no reaccionar. Ahora mi hijo me busca para contarme cosas del colegio.'
}, {
  name: 'Valentina',
  location: 'Rosario',
  initials: 'V',
  color: 'bg-maternal-gold',
  quote: 'Pensé que era otra guía más de internet. Pero los scripts son tan específicos que sabía exactamente qué decir cuando mi hija me contestaba mal. En una semana cambió todo.'
}, {
  name: 'Luciana',
  location: 'Mendoza',
  initials: 'L',
  color: 'bg-maternal-lightBrown',
  quote: 'Lo mejor es que mi hijo ni se dio cuenta de que estaba aplicando un método. Simplemente empezó a bajar la guardia. Hoy tenemos una relación que creí imposible.'
}];
export function TestimonialsSection() {
  return <section className="py-10 md:py-24 bg-maternal-beige" data-id="element-193">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-194">
        <div className="text-center mb-8 md:mb-16" data-id="element-195">
          <h2 className="text-3xl md:text-4xl font-bold text-maternal-brown mb-4" data-id="element-196">
            Lo que dicen las madres que ya lo aplicaron
          </h2>
          <p className="text-lg text-maternal-lightBrown max-w-2xl mx-auto" data-id="element-197">
            Historias reales de mujeres que transformaron el silencio y los
            gritos en conexión genuina.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8" data-id="element-198">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white p-6 md:p-8 rounded-2xl shadow-sm border border-maternal-cream hover:shadow-md transition-shadow duration-300 flex flex-col h-full" data-id="element-199">
              <div className="flex items-center mb-4" data-id="element-200">
                <div className={`w-12 h-12 rounded-full ${testimonial.color} text-white flex items-center justify-center font-bold text-lg mr-4 flex-shrink-0`} data-id="element-201">
                  {testimonial.initials}
                </div>
                <div data-id="element-202">
                  <h3 className="font-bold text-maternal-brown text-lg" data-id="element-203">
                    {testimonial.name}
                  </h3>
                  <p className="text-sm text-maternal-lightBrown/80" data-id="element-204">
                    {testimonial.location}, Argentina
                  </p>
                </div>
              </div>

              <div className="flex mb-4" data-id="element-205">
                {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-4 h-4 text-maternal-amber fill-current" data-id="element-206" />)}
              </div>

              <p className="text-maternal-lightBrown leading-relaxed italic flex-grow" data-id="element-207">
                "{testimonial.quote}"
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}